(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {
    
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };
    
})(jQuery);


$(window).scroll(function(event) {
  
  $("ul.left_right_alternating > li").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("come-in"); 
    } 
  });
  
}); 


$(document).ready(function() {
    //$('.revealable').addClass('hidden');
    //$('.revealable-content').css('display', 'none');    
    /*$('.revealable-trigger').click(function() {
        var p = $(this).parent();
        p.toggleClass('hidden');
        var c = $(this).next('.revealable-content');
        c.slideToggle();
    });*/
    $('.revealable').parents('ul.left_right_alternating li').click(function() {
        var r = $(this).children('.revealable');
        var c = r.children('.revealable-content');
        //c.slideToggle();
        r.toggleClass('hidden');
    });
    
    $('.revealable.popup .revealable-trigger').click(function() {
        var t = $(this);
        t.parent().toggleClass('hidden');
        //t.next('.revealable-content').css('display', 'block'); 
    });
    
    //close menu after click
    $('#menu li a').click(function() {
        $('#show-menu').prop('checked', false);
    })
});
